module.exports = "/images/vendor/desiigner-svg/svg/ui/play-arrow.svg?0cc8eb829f5c48a4ac29bac75e5bef6d";